import { MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE } from 'constants/content'
import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import GeoContext from 'contexts/geoContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { useContext } from 'react'
import { getCheapestSelectedPackageOptionWithDefault } from 'selectors/offerPageSelectors'

function useVillasPrice(): [number, number, number] {
  const { showTaxExclusivePrices } = useContext(GeoContext)

  const offerState = useContext(OfferPageStateContext)
  const packageView = useAppSelector(state => getCheapestSelectedPackageOptionWithDefault(state, offerState))

  const totalPrice = showTaxExclusivePrices ?
    packageView.hotelPrice :
    packageView.hotelPrice + (packageView.propertyFees ?? 0)
  const showValue = packageView.hotelValue > totalPrice && packageView.package.shouldDisplayValue
  const showDiscountPill = packageView.hotelDiscountPercent >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE
  const value = showValue ? packageView.hotelValue : 0
  const discount = showDiscountPill ? packageView.hotelDiscountPercent : 0

  return [totalPrice, value, discount]
}

export default useVillasPrice
